// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"51a26434","205":"55c8ea28","270":"51a26434","294":"55c8ea28","339":"51a26434","889":"51a26434"}[chunkId] + ".chunk.css";
};